import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import AmazonRDSWriterForm from '../forms/amazon-rds-writer-form';
import { amazonRDSWriterFormSchema } from '../schema/amazonRDSWriter.js';

export default function AmazonRDSWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Amazon RDS Writer Node Details',
        altText: 'Amazon RDS Writer Node',
        defaultLabel: 'RDS Writer Node',
      }}
    >
      <CommonNode FormComponent={AmazonRDSWriterForm} schemaResolver={amazonRDSWriterFormSchema} />
    </NodeProvider>
  );
}
